import { render, staticRenderFns } from "./AgeAlertMessage.vue?vue&type=template&id=dec39b06&"
import script from "./AgeAlertMessage.vue?vue&type=script&lang=js&"
export * from "./AgeAlertMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports